import {Component, Input} from '@angular/core';
import {StoreWorkingTime} from '../../../../../classes/models/store/StoreWorkingTime';
import {SHARED_IMPORTS} from "../../../../../shared/standalone-imports";

@Component({
  selector: 'app-working-times-form-timepicker',
  templateUrl: './working-times-form-timepicker.component.html',
  styleUrls: ['./working-times-form-timepicker.component.less'],
  imports: [SHARED_IMPORTS]
})
export class WorkingTimesFormTimepickerComponent {

  /** Opening and closing times of the store. */
  @Input() storeWorkingTime: StoreWorkingTime;
}
